import React from "react";
import { socials } from "../data/socialItems";

const SocialLinks = () => {
  return (
    <div className="hidden lg:flex fixed flex-col top-[35%] left-0 mr-4">
      <ul>
        {socials.map(({ id, name, icon, href, style }) => (
          <li
            key={id}
            className={
              "w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 hover:rounded-md " +
              style +
              " bg-gray-500 border-b border-solid border-black"
            }
          >
            <a
              className="flex justify-between items-center w-full text-gray-300"
              href={href}
              target="_blank"
              rel="noreferrer"
            >
              {name}
              {icon}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
